import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Search } from 'basic-components';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

import { statusesActions } from 'actions/modules/statuses';
import { routing } from 'routing';

import MainViewBlockMobile from './MainViewBlockMobile';
import SelectorButton from './SelectorButton';

import classNames from 'classnames';
import './MainViewMobile.scss';

const MainViewMobile = () => {
  const navigate = useNavigate(),
        { type } = useParams(),
        searchRef = useRef(),
        [searchParams] = useSearchParams(),
        [query, setQuery] = useState(searchParams.get("query") || ""),
        [selector, setSelector] = useState(searchParams.get("selector") || ""),
        onSelectorChange = useCallback(id => setSelector(prevSelector => prevSelector === id ? undefined : id), []),
        changeCategory = useCallback(category => {
          const categoryCapitalized = category.charAt(0).toUpperCase() + category.toLowerCase().slice(1)
          navigate(DashboardLinkFactory.statuses.list({ baseUrl: "", type: categoryCapitalized }))
        }, [navigate])

  useEffect(() => {
    if(type !== routing.dataScience.readableName && type !== routing.dataLake.routing.groups.name){ // if url parameter type is different than Pipelines or Groups - redirect to statuses home page
      navigate(DashboardLinkFactory.statuses.list({ baseUrl: "", rawQuery: window.location.search, type: routing.dataScience.readableName }))
      return;
    }
    const url = DashboardLinkFactory.statuses.list({ baseUrl: "", query, selector: selector || "", type })
    if((window.location.pathname + window.location.search) !== url) {
      navigate(url)
    }
  }, [query, navigate, type, selector])

  return (
    <div className="statuses-main-view-mobile">
      <div className="statuses-main-view-mobile__header">
        <div className="statuses-main-view-mobile__header__search">
          <Search
              autoCapitalize="off"
              autoComplete="off"
              autoCorrect="off"
              autoFocus={false}
              defaultValue={query}
              onSearch={setQuery}
              placeholder="Search for status"
              ref={searchRef}
              size="normal"
              variant="outline"
          />
        </div>
        <div className="statuses-main-view-mobile__header__selectors">
          <div className="statuses-main-view-mobile__header__selectors__title">
            Show only:
          </div>
          <div className="statuses-main-view-mobile__header__selectors__elements">
            <SelectorButton
                bgColor="orange-base"
                icon="Warning"
                isGreyed={!!selector && selector !== statusesActions.SELECTORS.WARNING}
                isSelected={selector === statusesActions.SELECTORS.WARNING}
                onSelectorChange={onSelectorChange}
                selector={statusesActions.SELECTORS.WARNING}
            />
            <SelectorButton
                bgColor="red-base"
                icon="Error"
                isGreyed={!!selector && selector !== statusesActions.SELECTORS.ERROR}
                isSelected={selector === statusesActions.SELECTORS.ERROR}
                onSelectorChange={onSelectorChange}
                selector={statusesActions.SELECTORS.ERROR}
            />
            <SelectorButton
                bgColor="blue-bright"
                icon="Running"
                isGreyed={!!selector && selector !== statusesActions.SELECTORS.RUNNING}
                isSelected={selector === statusesActions.SELECTORS.RUNNING}
                onSelectorChange={onSelectorChange}
                selector={statusesActions.SELECTORS.RUNNING}
            />
            <SelectorButton
                bgColor="purple-base"
                icon="Pause"
                isGreyed={!!selector && selector !== statusesActions.SELECTORS.PAUSE}
                isSelected={selector === statusesActions.SELECTORS.PAUSE}
                onSelectorChange={onSelectorChange}
                selector={statusesActions.SELECTORS.PAUSE}
            />
          </div>
        </div>
        <div className="statuses-main-view-mobile__header__categories">
          <button 
              className={classNames(
                "statuses-main-view-mobile__header__categories__element",
                { "statuses-main-view-mobile__header__categories__element--current": type === routing.dataScience.readableName }
              )}
              onClick={() => changeCategory(routing.dataScience.readableName)}
          >
            {routing.dataScience.readableName}
          </button>
          <button 
              className={classNames(
                "statuses-main-view-mobile__header__categories__element",
                { "statuses-main-view-mobile__header__categories__element--current": type === routing.dataLake.routing.groups.name }
              )}
              onClick={() => changeCategory(routing.dataLake.routing.groups.name)}
          >
            {routing.dataLake.routing.groups.name}
          </button>
        </div>
      </div>
      <MainViewBlockMobile
          category={type}
          query={query}
          selector={selector}
      />
    </div>
  )
}

export default MainViewMobile;
